export default "__VITE_ASSET__281sbcy3__"